import { Grid } from '@mui/material';

import { FormAutocompleteField, FormDateField, FormTextField } from '../../../../../../common';
import { RELATIONSHIP_TO_POLICYHOLDER_OPTIONS } from '../constants';

import type { InsuranceCoverageFieldsProps } from './types';

export default function InsuranceCoverageFields({
  formik,
  disabled,
  saveFieldOnBlur,
  insuranceStartDisabledDate,
  insuranceEndDisabledDate,
}: InsuranceCoverageFieldsProps) {
  return (
    <>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Insurance name"
          name="insurance_name"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Relationship to policyholder"
          name="relationship_to_policyholder"
          onChange={saveFieldOnBlur}
          options={RELATIONSHIP_TO_POLICYHOLDER_OPTIONS}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDateField
          disabled={disabled}
          disabledDate={insuranceStartDisabledDate}
          formik={formik}
          label="Insurance start date"
          name="insurance_start_date"
          onChange={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormDateField
          disabled={disabled}
          disabledDate={insuranceEndDisabledDate}
          formik={formik}
          label="Insurance end date"
          name="insurance_end_date"
          onChange={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Member ID"
          name="member_id"
          onBlur={saveFieldOnBlur}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Group number"
          name="group_number"
          onBlur={saveFieldOnBlur}
        />
      </Grid>
    </>
  );
}
